import { TreeviewItem } from "../bo/treeview/treeview-item";

export const TreeviewHelper = {
  findItem,
  findItemInList,
  findParent,
  concatSelection
};

function findItem(root: TreeviewItem, value: any): TreeviewItem {
  if (root === null || root === undefined) {
    return undefined;
  }

  if (root.value === value) {
    return root;
  }

  if (root.children) {
    for (const child of root.children) {
      const foundItem = findItem(child, value);
      if (foundItem) {
        return foundItem;
      }
    }
  }

  return undefined;
}

function findItemInList(list: TreeviewItem[], value: any): TreeviewItem {
  if (list === null || list === undefined) {
    return undefined;
  }

  for (const item of list) {
    const foundItem = findItem(item, value);
    if (foundItem) {
      return foundItem;
    }
  }

  return undefined;
}

function findParent(root: TreeviewItem, item: TreeviewItem): TreeviewItem {
  if (root === null || root === undefined || root.children === undefined || root.children === null) {
    return undefined;
  }

  for (const child of root.children) {
    if (child === item) {
      return root;
    } else {
      const parent = findParent(child, item);
      if (parent) {
        return parent;
      }
    }
  }

  return undefined;
}

function concatSelection(items: TreeviewItem[], checked: TreeviewItem[], unchecked: TreeviewItem[]): { [k: string]: TreeviewItem[] } {
  let checkedItems = [...checked];
  let uncheckedItems = [...unchecked];
  for (const item of items) {
    const selection = item.getSelection();
    checkedItems = [...checkedItems, ...selection.checkedItems];
    uncheckedItems = [...uncheckedItems, ...selection.uncheckedItems];
  }
  return {
    checked: checkedItems,
    unchecked: uncheckedItems
  };
}
